import { isiOS, isMacOS } from "@tiptap/core"

export const isApple = isiOS() || isMacOS()
export const modKeyText = isApple ? "⌘" : "Ctrl"
